import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from '../../../../common/api-url-helper';
import { CommonService } from '../../../../services/common/common.service';
import { StateService } from '../../../../services/common/claim-year.service';
import { Router } from '@angular/router';
import {
  CommonLabelConstant,
  UtilityFormConstants,
} from '../../../../constants/label-constants';
import { environment } from '../../../../../environments/environment';
import { SharedService } from '../../../../services/shared-service/shared.service';
import { ToastrService } from 'ngx-toastr';
import { CommonErrorMessages } from '../../../../constants/error-messages';
import { RoleRightsService } from '../../../../services/common/role-rights.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../../services/common/validation-service';

@Component({
  selector: 'app-utility-form',
  templateUrl: './utility-form.component.html',
  styleUrls: ['./utility-form.component.scss'],
})
export class UtilityFormComponent implements OnInit {
  @Input() isParentLocked: boolean = false;
  havePermission: boolean = false;
  projectList: any = [];
  companyId: any = 0;
  claimYearId: any = 0;
  detail: any = {};
  utilityData: any[] = [];
  isLoading: boolean = false;
  onDestroy$: Subject<void> = new Subject();
  projects: any[] = [];
  utilityTotals: any[] = [];
  env: any = environment;
  commonErrorMessages = CommonErrorMessages;
  labelConstants: any = UtilityFormConstants;
  selectedBusinessAverageOption!: number;
  businessAverage!: number;

  businessAverageOptions = [
    { id: 1, value: 'Pre-calculated business average' },
    { id: 2, value: 'Other' },
  ];
  totalQualifyingCosts: any;
  isLocked: boolean = false;
  commonLabelConstants = CommonLabelConstant;
  getUtilityCostData: any;

  constructor(
    private readonly api: ApiUrlHelper,
    private readonly toastr: ToastrService,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly spinner: NgxSpinnerService,
    private readonly sharedService: SharedService,
    private readonly router: Router,
    private readonly roleRightsService: RoleRightsService,
    private readonly validationService:ValidationService
  ) {}

  ngOnInit() {
    this.roleRightsService.hasAccess('isAdd');
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId ?? null;

      if (this.companyId && this.claimYearId) {
        this.getProjectListCompanyWise(this.companyId, this.claimYearId);
      }
    });

    this.sharedService.gethavePermission().subscribe((data) => {
      this.havePermission = data;
    });
  }

  getProjectListCompanyWise(companyId: any, claimYearId: any) {
    this.spinner.show();
    const api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace(
      '{companyId}',
      companyId
    ).replace('{claimYearId}', claimYearId);

    this.commonService
      .doGet(api)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response.success) {
            this.projectList = response.data;
          } else {
            this.projectList = [];
          }
          this.getUtilityCost();
        },
        error: (error: any) => {
          this.spinner.hide();
          console.log(error);
        },
      });
  }

  getTotal(totalQualifyingCosts: any, utilityCosts: any): any {
    return totalQualifyingCosts * utilityCosts
      ? (totalQualifyingCosts * utilityCosts) / 100
      : 0;
  }

  getUtilityDetails() {
    this.isLoading = true;
    const api = this.api.apiUrl.UtilityResource.GetUtilityResourceList;
    const obj = {
      companyId: this.companyId,
      claimYearId: this.claimYearId,
    };

    this.commonService
      .doPost(api, obj)
      .pipe()
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.success) {
            if (response?.data.length === 0) {
              this.isLocked = this.isParentLocked;
            } else {
              this.detail = response.data;
              this.isLocked = this.detail?.isLocked ?? false;
              this.projects = this.detail.projects;
              this.totalQualifyingCosts =
                this.getUtilityCostData?.isPreCalculated == true
                  ? this.detail.totalQualifyingCostsPreCalculated
                  : this.detail.totalQualifyingCosts;
              this.utilityData = this.detail.projects.map((item: any) => {
                const projects = this.projectList?.map((projectDetail: any) => {
                  const projectData = item.projects?.find(
                    (proj: any) => proj.projectId === projectDetail.projectId
                  ) || { utilityCosts: '0' };

                  return {
                    projectId: projectDetail.projectId,
                    utilityCosts: projectData.utilityCosts,
                  };
                });
                this.updateTotals();

                return {
                  utilityId: item.utilityId,
                  descriptionOfLicence: item.descriptionOfLicence,
                  utilityResourceId: item.utilityResourceId,
                  totalGross: item.cost,
                  totalEligibilityPer: item.totalEligibilityAmount,
                  projects: projects,
                };
              });
            }
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          console.log(error);
          this.spinner.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.spinner.hide();
        },
      });
  }

  save() {
    if (this.isLocked) {
      this.toastr.error(this.commonErrorMessages.ClaimLocked);
      return;
    }
    if (!this.havePermission) {
      this.toastr.error(this.commonErrorMessages.ActionNotPermitted);
      return;
    }
    if (this.businessAverage == undefined || this.businessAverage == 0) {
      this.toastr.error('Business average can not be zero or empty.');
      return;
    } else {
      let obj = {
        CompanyId: this.companyId,
        ClaimYearId: this.claimYearId,
        BusinessAverage: this.businessAverage,
        IsPreCalculated: this.selectedBusinessAverageOption == 1 ? true : false,
      };
      this.spinner.show();
      let api = this.api.apiUrl.UtilityResource.SaveUtilityCost;
      this.commonService
        .doPost(api, obj)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response.success) {
              this.toastr.success(response.message);
              this.isLoading = false;
            } else {
              this.toastr.error(response.message);
              this.isLoading = false;
            }
          },
          error: (error) => {
            this.spinner.hide();
            console.log(error);
            this.isLoading = false;
          },
        });
    }
  }

  getUtilityCost() {
    let obj = {
      CompanyId: this.companyId,
      ClaimYearId: this.claimYearId,
    };
    this.spinner.show();
    let api = this.api.apiUrl.UtilityResource.GetUtilityCost;
    this.commonService
      .doPost(api, obj)
      .pipe()
      .subscribe({
        next: (response) => {
          this.getUtilityDetails();
          this.getUtilityCostData = response.data;
          this.spinner.hide();
          this.isLoading = false;
          this.businessAverage = this.getUtilityCostData?.businessAverage
            ? this.getUtilityCostData?.businessAverage
            : 0;
          this.selectedBusinessAverageOption =
            this.getUtilityCostData?.isPreCalculated == true ? 1 : 2;
        },
        error: (error) => {
          this.spinner.hide();
          console.log(error);
          this.isLoading = false;
        },
      });
  }

  calculate() {
    if (this.selectedBusinessAverageOption == 1) {
      this.businessAverage = this.detail?.businessAveragePreCalculated
        ? this.detail?.businessAveragePreCalculated
        : 0;
    } else {
      this.businessAverage = this.getUtilityCostData?.businessAverage
        ? this.getUtilityCostData?.businessAverage
        : 0;
    }
    this.businessAverageChange();
  }

  businessAverageChange() {
    if (this.selectedBusinessAverageOption == 1) {
      this.totalQualifyingCosts = !isNaN(
        Number(this.detail.businessAveragePreCalculated)
      )
        ? (Number(this.detail.businessAveragePreCalculated) *
            this.detail.totalUtilityCost) /
          100
        : 0;
    } else {
      this.totalQualifyingCosts = !isNaN(Number(this.businessAverage))
        ? (Number(this.businessAverage) * this.detail.totalUtilityCost) / 100
        : 0;
    }
    this.updateTotals();
  }

  updateTotals() {
    this.utilityTotals = this.detail.projects.map((item: any) => {
      return this.totalQualifyingCosts && item.utilityCosts
        ? this.getTotal(this.totalQualifyingCosts, item.utilityCosts)
        : 0;
    });
  }

  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  exportList(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
    };
    let api = this.api.apiUrl.UtilityResource.ExportUtilityCost;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Water, Fuel and Power - R&D Project Resources & Eligibility.xlsx";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
